import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EFPicture from '@elem/ui/ef-picture';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');
    const [enter, setEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const box = document.querySelector(`.vs-box`);
            if (box) {
                AniContainer.create({
                    triggerElement: box,
                    triggerHook: 1,
                    offset: '20%',
                    duration: '100%',
                    onEnter: () => setEnter(true),
                    onLeave: () => setEnter(false),
                });
            }
        }
    }, []);

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec" />
            <EfSection
                pc="https://websiteoss.ecoflow.com/upload/image/1721187698316/pc_compare.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1721187738376/m_compare.jpg"
                label={t('J_label')}
                title={t('J_title')}
                desc={t('J_desc')}
            />
            <div className={`vs-box ${enter ? 'enter' : ''} enter`}>
                <div className="row row1">
                    <div className="col compare">
                        <EFPicture src={'https://websiteoss.ecoflow.com/upload/image/1721188132605/compare_01.png'} alt={t('J_item1_title')} />
                    </div>
                    <div className="col mid vs">{t('J_vs')}</div>
                    <div className="col compare">
                        <EFPicture src={'https://websiteoss.ecoflow.com/upload/image/1721188164954/compare_02.png'} alt={t('J_item2_title')} />
                    </div>
                </div>
                <div className="row row2">
                    <div className="col compare title">{t('J_item1_title')}</div>
                    <div className="col mid"></div>
                    <div className="col compare title">{t('J_item2_title')}</div>
                </div>
                <div className="row com">
                    <div className="col compare">
                        <div className="bg-bar prop1 l">
                            <div className="cor-bar">
                                <span className="text">{t('J_item1_prop1')}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col mid">{t('J_prop1')}</div>
                    <div className="col compare">
                        <div className="bg-bar prop1 r">
                            <div className="cor-bar">
                                <span className="text">{t('J_item2_prop1')}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row com">
                    <div className="col compare">
                        <div className="bg-bar prop2 l">
                            <div className="cor-bar">
                                <span className="text">{t('J_item1_prop2')}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col mid">{t('J_prop2')}</div>
                    <div className="col compare">
                        <div className="bg-bar prop2 r">
                            <div className="cor-bar">
                                <span className="text">{t('J_item2_prop2')}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row com">
                    <div className="col compare">
                        <div className="bg-bar prop3 l">
                            <div className="cor-bar">
                                <span className="text">{t('J_item1_prop3')}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col mid">{t('J_prop3')}</div>
                    <div className="col compare">
                        <div className="bg-bar prop3 r">
                            <div className="cor-bar">
                                <span className="text">{t('J_item2_prop3')}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EfSpec className="spec" />
        </div>
    );
}
